
import { createSlice } from "@reduxjs/toolkit";
import { getInventory } from "../reduxApi/inventoryReduxApi";

const inventorySlice = createSlice({
    name: 'inventory',
    initialState: {
        status: 'idel',
        inventory: [],
    },
    reducers: {
        deleteinventoryAction: (state, action) => {
            state.inventory = state.inventory.filter(item => !action.payload.includes(item?.ROWID));

        },
        updateinventoryAction: (state, action) => {
            console.log("action", action.payload)
             const index = state.inventory.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.inventory.splice(index, 1, action.payload)
    
            }
        },
        addinventoryAction: (state, action) => {
            console.log("Adding inventory:", action.payload);
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID;
            state.inventory.unshift(temp);
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getInventory.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getInventory.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("testing inventory Data", action.payload)
                state.inventory = action.payload.data.inventoryResp
;
            })
    }
})
export const { deleteinventoryAction, updateinventoryAction, addinventoryAction } = inventorySlice.actions
export default inventorySlice.reducer